module.exports = __webpack_public_path__ + "static/img/detail-bg-new-h5.4221dbad.png";